import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../Section';
import { PromoBanner as PromoBannerComponent } from '../../PromoBanner';

export const PromoBanner = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow'} {...rest}>
    <PromoBannerComponent {...data} />
  </Section>
);

export const PromoBannerQuery = graphql`
  fragment PromoBanner on KFH_UmbracoPromoBannerComponentType {
    title
    description
    link {
      url
      target
      type
      name
      page {
        relativeUrl
        pageName
      }
    }
    smallImage: backgroundImage {
      altText
      localFile {
        gatsbyImage(
          width: 800
          height: 800
          layout: FULL_WIDTH
          placeholder: NONE
          quality: 90
          backgroundColor: "#F5F5F5"
        )
      }
    }
    largeImage: backgroundImage {
      altText
      localFile {
        gatsbyImage(
          width: 1120
          height: 280
          layout: FULL_WIDTH
          placeholder: NONE
          quality: 90
          backgroundColor: "#F5F5F5"
        )
      }
    }
  }
`;
